import * as React from "react"

const Checkout = () => {
  return (
    <iframe
      src="https://meetonline.io/molb/public_html/checkout/"
      height="100%"
      width="100%"
      title="Checkout Form"
    />
  )
}
export default Checkout
